export default __webpack_public_path__ + "static/media/bg.0ca66d15.png";